import { Component, OnInit } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { SeguridadService } from './services/seguridad.service';
import { Usuario } from './model/usuario';
import { Permisos } from './model/permisos';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public usuario: Usuario = new Usuario();
  public permisos: Permisos[];

  public mantenimientos: Permisos[];
  public procesos: Permisos[];
  public reportes: Permisos[];

  title = 'app works!';

  constructor(
    private _seguridadService: SeguridadService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {

   
  }



 

  /*OrdenarPermisos(arr) {
    var Menu = {};
    for (var i = 0; i < arr.length; i++) {
      if (!Menu.hasOwnProperty(arr[i].CODIGOCATEGORIA)) {
        Menu[arr[i].CODIGOCATEGORIA] = [];
      }
      Menu[arr[i].CODIGOCATEGORIA].push(arr[i]);
    }
    return Menu;
  };

  CrearMenu(obj) {
    var num = 0;
    for (var key in obj) {
      num ++;
      this.CrearCategorias(key, obj[key], num);
    }
  };


  CrearCategorias(cat, arr, num) {
    var Menu = document.getElementById("Menu_Tags");
    var LI = document.createElement("LI");
    LI.setAttribute("class", "nav-item dropdown item-menu-drop")
    var A = document.createElement("A");
    A.setAttribute("class", "nav-link dropdown-toggle");
    A.setAttribute("data-toggle", "dropdown");
    A.setAttribute("aria-haspopup", "true");
    A.setAttribute("aria-expanded", "false");
    A.setAttribute("id","dropdown0"+num);
    A.innerHTML = cat;
    LI.appendChild(A);
    var DIV = document.createElement("DIV");
    DIV.setAttribute("class","dropdown-menu");
    DIV.setAttribute("aria-labelledby","dropdown0"+num);
    for (var i = 0; i < arr.length; i++) {
      var LINK = document.createElement("A");
      LINK.innerHTML = arr[i].NOMBREPERMISO;
      LINK.setAttribute("class","dropdown-item");      
     /*LINK.setAttribute("href","/"+arr[i].RUTA);*/
  /* var ATTR = document.createAttribute("routerLink");
ATTR.value = "/" + arr[i].RUTA + "";
LINK.setAttributeNode(ATTR);
DIV.appendChild(LINK);
 }
LI.appendChild(DIV);
Menu.appendChild(LI);

};*/



}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/app.component.ts